import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'

// isPrivileged: internal staff (admin/support) — destructive actions, LTI login toggles
// canEdit: anyone allowed to call the edit endpoints (includes external admins)
export let startLTI13Dashboard = (isPrivileged, canEdit = isPrivileged) => {
  const root = createRoot(document.getElementById('lti13App'))
  root.render(<App isPrivileged={isPrivileged} canEdit={canEdit} />)
}
